export const isHebrew = (str: string) => {
  if (str) {
    return str.search(/[\u0590-\u05FF]/) >= 0;
  }
  return false;
};
